import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMessageStore = defineStore('message', () => {
  const count = ref(0)
  function setCount(val: number) {
    count.value = val
  }
  return { count, setCount }
})
